// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2LAEE","insightsList":"newBusinessInsightsMenu_insightsList__3TmOJ","active":"newBusinessInsightsMenu_active__ZChyC"};